/// <reference path="../../../../../typings.d.ts" />

import { Component } from '@angular/core';
import 'file-saver';
import { ForSigningHttpService } from '../../../../services/forsigning/forsigning.http.service';
import { ForSigningHttpUtil } from '../for-signing.util';
import { StorageUtil } from '../../../../utils/storage.util';
import { ForSigningModelService } from '../for-signing.model.service';
import { AuthUtil } from '../../../../utils/auth.utils';
import { Router } from '@angular/router';
import { ReportHttpService } from '../../../../services/report/report.http.service';
import { CALENDAR_LOCALE_RU } from '../../../../consts/locale';
import { DeclineDialogContractStateService } from '../decline/decline.dialog.state.service';

@Component({
  moduleId: module.id,
  templateUrl: 'forsigning.list.component.html',
  styleUrls: ['forsigning.list.component.css'],
  providers: []
})

export class ForSigningListComponent {

  model = [];
  search: any = '';
  searchList = [];
  loadBtnStatus;

  pageLoading = true;
  errorMessage: string;
  serverValidationErrorMessage: any;

  getContractsSubscription: any;

  declineEpId = -1;
  contractsForSigningCount = 0;

  constructor(
    private contractHttpService: ForSigningHttpService, 
    private contractModelService: ForSigningModelService, 
    private authUtil: AuthUtil, 
    private router: Router, 
    private reportHttpService: ReportHttpService,
    private declineDialogContractStateService: DeclineDialogContractStateService,) {
    this.getContractsForSigningCount();
    this.getContracts();
  }

  ngOnInit() {
    window.onresize = function() {
        const table = document.querySelector('.pane-vScroll');
        if (table) {
          table.setAttribute('style', 'width: 100%');
        }
    };
  }
  getContractsForSigningCount() {
    const data = {
      securityToken: StorageUtil.getToken(),
    };
    
    const requestParams = ForSigningHttpUtil.prepareParamsContracts(data);
    this.contractHttpService.getContractsForSigningCount(requestParams).subscribe(
      success => {
            const data = success.json().response;
            this.contractsForSigningCount = data.count;
            if (this.contractsForSigningCount == 0) {
              this.pageLoading = true;
              this.router.navigate(['/contracts']);
            }
      },
      error => {
        this.pageLoading = true;
        this.router.navigate(['/contracts']);
      }
    );
  }

  getContracts() {
    this.errorMessage = '';
    this.pageLoading = true;

    const data = {
      securityToken: StorageUtil.getToken(),
    };
    
    const requestParams = ForSigningHttpUtil.prepareParamsContracts(data);
    this.getContractsSubscription = this.contractHttpService.getContracts(requestParams).subscribe(
      success => {
        if (success) {
          this.pageLoading = false;
          const data = success.json();
          if (this.authUtil.isError(data)) {
            this.errorMessage = this.authUtil.errorMessage(data);
            this.authUtil.checkErrorResponse(data);
          } else {
            // TODO: refactoring
              this.model = data.response && data.response.items || [];
              this.searchList = this.model;

            if (this.searchList.length > 0) {
              this.loadBtnStatus = true;
            }
          }
        }
      }, error => {
        console.log(error);
        if (error.status === 422) {
          this.serverValidationErrorMessage = error.json().errors;
        } else {
          // this.errorMessage = 'Произошла ошибка.';
        }
        this.searchList = [];
        this.pageLoading = false;
        this.loadBtnStatus = true;
      },
      () => {
        this.pageLoading = false;
      });
  }

  navigate($event, id) {
    $event.preventDefault();
    this.pageLoading = true;
    this.router.navigate(['forsigning/' + id + '/objects']);
  }

  openChatDialogForItem($event, id) {
    $event.preventDefault();
    this.declineEpId = id;
    this.openChatDialog($event);
  }

  openChatDialog($event) {
    $event.preventDefault();
    this.declineDialogContractStateService.triggerDialogStatus({display: true})
  }

  agree($event, epId) {
    $event.preventDefault();
    this.pageLoading = true;
    delete this.errorMessage;

    let data = {
      securityToken: StorageUtil.getToken()
    };
    let requestParams = ForSigningHttpUtil.prepareParamsAgree(data);
    this.contractHttpService.postAgreeContract(epId, requestParams).subscribe(
      success => {
        if (success) {
          this.pageLoading = false;
          this.authUtil.checkErrorResponse(success.json());
          window.location.reload();
        }
      },
      error => {
        this.pageLoading = false;
        this.errorMessage = 'Произошла ошибка.';
      },
      () => {
        this.pageLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/list/forsigning.list.component.ts